import { render, staticRenderFns } from "./AddCredit.vue?vue&type=template&id=5dd80fbe&"
import script from "./AddCredit.vue?vue&type=script&lang=js&"
export * from "./AddCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports